export function initTabbedContent() {

	const tabButtons = document.querySelectorAll('[data-tab-target]');
	if (!tabButtons.length) return;
	tabButtons.forEach((button) => toggleTabs(button));

	const accordionButtons = document.querySelectorAll('[data-accordion-target]');
	accordionButtons.forEach((button) => toggleAccordions(button));

	//set initial height for open accordions to prevent animation jump on first-time click
	const openAccordions = document.querySelectorAll('[data-tabbed-accordion-group]');
	console.log('openAccordions.length=' + openAccordions.length);
	openAccordions.forEach(accordionContent => {
		if (accordionContent.parentElement.classList.contains('expanded')) {
			console.log('expanded');
			accordionContent.style.height = accordionContent.scrollHeight + 'px';
		}
		else {
			console.log('not');
			accordionContent.style.height = '0px';
		}
	});
}

function toggleTabs(tab_button) {
	tab_button.addEventListener('click', (e) => {

		const targetGroup = document.querySelector(`[data-tab-group="${ tab_button.dataset.tabTarget }"]`);
		const currentGroup = document.querySelector('.tabbed-content__tab-content.active');
		const currentButton = document.querySelector('.tabbed-content__tab-toggle.active');
		
		if (targetGroup === currentGroup) {
			return;
		}

		currentGroup.classList.remove('active');
		currentButton.classList.remove('active');

		tab_button.classList.add('active');
		targetGroup.classList.add('active');
	});
}

function toggleAccordions(accordion_button) {
	accordion_button.addEventListener('click', (e) => {
		
		const targetGroup = document.querySelector(`[data-tabbed-accordion-group="${ accordion_button.dataset.accordionTarget }"]`);
		const currentTab = accordion_button.closest('[data-tab-group]');
		const currentGroup = currentTab.querySelector('.tabbed-content__accordion-group.expanded .tabbed-content__accordion-content');

		if (currentGroup && currentGroup !== targetGroup) {
			currentGroup.parentElement.classList.remove('expanded');
			currentGroup.style.height = '0px'; 

			targetGroup.parentElement.classList.add('expanded');
			targetGroup.style.height = targetGroup.scrollHeight + 'px';
		}
		else if (currentGroup && currentGroup === targetGroup) {
			targetGroup.parentElement.classList.remove('expanded');
			targetGroup.style.height = '0px';
		}
		else {
			targetGroup.parentElement.classList.add('expanded');
			targetGroup.style.height = targetGroup.scrollHeight + 'px';
		}

	});
}


// WEBPACK FOOTER //
// ./scripts/modules/tabbed-content.js